import { Link, tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';

const headings = [
  'shared:moreInformation.items.amortization.heading1',
  'shared:moreInformation.items.amortization.heading2',
];

const paragraphs = [
  'shared:moreInformation.items.amortization.paragraph1',
  'shared:moreInformation.items.amortization.paragraph2',
];

const externalLink = 'shared:moreInformation.items.amortization.link';

const CreateSectionContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Body>{t(headings[0])}</Typography.Body>
      <Typography.Body
        marginBottom={tokens.size.spacingLg}
        marginTop={tokens.size.spacing2xs}
      >
        {t(paragraphs[0])}
      </Typography.Body>
      <Typography.Body>{t(headings[1])}</Typography.Body>
      <Typography.Body marginTop={tokens.size.spacing2xs}>
        {t(paragraphs[1])}
      </Typography.Body>
      <Link marginTop={tokens.size.spacingMd}>
        <a
          href={'https://danskebank.se/privat/produkter/bolan/amorteringskrav'}
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          {t(externalLink)}
        </a>
      </Link>

    </>
  );
};

export const amortizationRulesData = {
  key: 'amortization-rules-data',
  text: 'shared:moreInformation.items.amortization.title',
  content: <CreateSectionContent />,
};
